import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class Glow {
    static init() {
        this.glows = document.querySelectorAll(".glow");

        if (this.glows.length > 0 && ScrollTrigger.isTouch !== 1) {
            this.initGlows();
        }
    }

    static initGlows() {
        this.glows.forEach((glow) => {
            let innerDiv = document.createElement("div");
            innerDiv.classList.add("inner-glow");
            glow.appendChild(innerDiv);

            gsap.set(glow, {opacity: 0});
            gsap.to(glow, {
                opacity: glow.dataset.opacity ? glow.dataset.opacity : 0.4,
                duration: 1,
                ease: "power1.out"
            });
        });

        const getRandomFloat = (min, max) => {
            return Math.random() * (max - min) + min;
        };

        this.glows.forEach((glow) => {
           const item = glow.querySelector(".inner-glow");

            gsap.to(item, {
                scale: 2,
                duration: getRandomFloat(3, 6),
                repeat: -1,
                yoyo: true,
                ease: "power1.inOut",
                // Décalage aléatoire pour chaque élément
                delay: getRandomFloat(1.5, 2)
            });

            gsap.to(item, {
                y: "+=20%",
                duration: getRandomFloat(1.5, 2),
                repeat: -1,
                yoyo: true,
                ease: "power1.inOut",
                // Décalage aléatoire pour chaque élément
                delay: getRandomFloat(1.5, 2)
            });

            gsap.to(item, {
                x: "+=25%",
                duration: getRandomFloat(1.5, 2),
                repeat: -1,
                yoyo: true,
                ease: "power1.inOut",
                // Décalage aléatoire pour chaque élément
                delay: getRandomFloat(1.5, 2)
            });
        });

        const onPageLoad = () => {

        };
    }
}
